// Behavior that keeps annotation selected even after a new annotation is added.
// See https://pspdfkit.com/guides/web/current/knowledge-base/keep-current-annotation-tool-enabled/ for more details.
export function usePersistentAnnotationBehavior(instance) {
  let newAnnontation = null;
  const annotationClass = PSPDFKit.Annotations.CommentMarkerAnnotation;
  const interactionMode = PSPDFKit.InteractionMode.COMMENT_MARKER;

  instance.addEventListener('annotations.create', annotations => {
    if (annotations.size !== 1 || instance.viewState.interactionMode !== interactionMode) {
      return;
    }

    const annotation = annotations.get(0);

    if (annotation instanceof annotationClass) {
      newAnnontation = annotation;
    }
  });

  instance.addEventListener('annotationSelection.change', annotation => {
    if (annotation === null && newAnnontation) {
      instance.setViewState(state => state.set('interactionMode', interactionMode));
    }

    newAnnontation = null;
  });
}
